import { createContext, useContext } from "react";
import { TASK_STATUS, APPLICABILITY, REQUEST_STATUS, DOC_STATUS, ASSIST_STATUS, INVOICE_STATUS } from "@/lib/api";
import { useLang } from "@/i18n";

const MAPS = { task: TASK_STATUS, applicability: APPLICABILITY, request: REQUEST_STATUS, doc: DOC_STATUS, assist: ASSIST_STATUS, billing: INVOICE_STATUS };

export const StatusBadge = ({ status, kind = "task", testId }) => {
  const s = MAPS[kind][status] || { label: status, cls: "bg-slate-100 text-slate-700 border-slate-300" };
  const { t } = useLang();
  return (
    <span data-testid={testId} className={`inline-flex items-center whitespace-nowrap rounded-full border px-2.5 py-0.5 text-xs font-semibold ${s.cls}`}>
      {t(s.label)}
    </span>
  );
};

export const InPanel = createContext(false);
export const PageHeader = ({ title, subtitle, children }) => (
  <div className="mb-6 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between fade-up">
    <div>
      {!useContext(InPanel) && <h1 className="font-heading text-2xl font-extrabold tracking-tight sm:text-3xl" data-testid="page-title">{title}</h1>}
      {subtitle && <p className="mt-1 text-sm text-muted-foreground">{subtitle}</p>}
    </div>
    {children && <div className="flex flex-wrap gap-2">{children}</div>}
  </div>
);

export const StatCard = ({ label, value, icon: Icon, tone = "default", testId }) => {
  const tones = { default: "text-primary", danger: "text-red-600", warn: "text-amber-600", ok: "text-emerald-700" };
  return (
    <div className="rounded-lg border bg-card p-5 transition-colors hover:border-primary/40 fade-up" data-testid={testId}>
      <div className="flex items-center justify-between">
        <span className="text-xs font-medium uppercase tracking-wider text-muted-foreground">{label}</span>
        {Icon && <Icon className={`h-4 w-4 ${tones[tone]}`} />}
      </div>
      <div className={`mt-3 font-heading text-3xl font-extrabold ${tones[tone]}`}>{value}</div>
    </div>
  );
};

export const EmptyState = ({ title, hint, testId, action }) => (
  <div className="rounded-lg border border-dashed bg-card p-10 text-center" data-testid={testId}>
    <p className="font-heading font-semibold">{title}</p>
    {hint && <p className="mt-1 text-sm text-muted-foreground">{hint}</p>}
    {action && <div className="mt-4">{action}</div>}
  </div>
);

export const Field = ({ label, children }) => (
  <label className="block space-y-1.5">
    <span className="text-xs font-medium uppercase tracking-wider text-muted-foreground">{label}</span>
    {children}
  </label>
);
